import { Component, OnInit } from '@angular/core';
import { ModuleAccessService } from '@services/module-access.service';

/**
 * Barra de anuncio de la migración "Services dentro de Flows" (ticket SUIT/CLM).
 *
 * Avisa una vez de que la gestión de contratos ya se alcanza desde Flows. Se
 * descarta y no vuelve: un anuncio permanente deja de leerse y solo roba alto de
 * pantalla. La clave de descarte lleva versión, para poder anunciar la etapa
 * siguiente sin resucitar este aviso.
 */
@Component({
  selector: 'app-migration-notice',
  templateUrl: './migration-notice.component.html',
  // Sin styleUrls a propósito: los estilos viven en scss/_migration-notice.scss
  // porque tienen que correr la navbar y el contenido, fuera de su encapsulación.
  standalone: false
})
export class MigrationNoticeComponent implements OnInit {

  static readonly DISMISS_KEY = 'suite.migrationNotice.servicesToFlows.v1';

  visible = false;
  link = '/flows/contratos';

  constructor(private moduleAccess: ModuleAccessService) {}

  ngOnInit() {
    // Solo tiene sentido para quien tiene el módulo de contratos: a los demás no
    // se les anuncia una pantalla a la que no pueden entrar. Tras la migración,
    // "services" ya no es un módulo del catálogo: su reemplazo es CLM.
    if (!this.moduleAccess.canNavigate('clm')) return;

    this.link = this.moduleAccess.getModuleLink('clm') || '/flows/contratos';
    this.visible = !this.isDismissed();
  }

  dismiss() {
    this.visible = false;
    try {
      localStorage.setItem(MigrationNoticeComponent.DISMISS_KEY, '1');
    } catch {
      // Si localStorage no está disponible el aviso reaparecerá; es preferible
      // a romper el layout por no poder guardar una preferencia.
    }
  }

  private isDismissed(): boolean {
    try {
      return localStorage.getItem(MigrationNoticeComponent.DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  }
}
